
import { Routes } from '@angular/router';
import { WelcomeComponent } from '../components/welcome/welcome.component';
import { BlankPageComponent } from './blank-page/blank-page.component';
import { LogoutComponent } from './logout/logout.component';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';


const coreRoutes: Routes = [
  {
    path: '',
    component: WelcomeComponent
  },
  {
    path: 'blank',
    component: BlankPageComponent,
  },
  {
    path: 'dashboard',
    component: WelcomeComponent
  },
  {
    path: 'performancedashboard',
    loadChildren: () => import('../performancedashboard/performancedashboard.module').then(m => m.PerformanceDashboardModule)
  },
  {
    path: 'misc',
    loadChildren: () => import('../misc/misc.module').then(m => m.MiscModule)
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
      path: '**',
      component: WelcomeComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(coreRoutes)
  ],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
